/** @format */
import { useRef } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";

function Minimap({ location, locations, zoom, onSelectData }) {
  const popupRef = useRef();

  function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
    return null;
  }

  if (location) {
    if (!location[0] || !location[1]) {
      location = [41.19769528327506, 64.27914651336707];
      zoom = 6;
    }
  }

  return (
    <MapContainer center={location} zoom={zoom}>
      <ChangeView center={location} zoom={zoom} />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {locations.map((l, i) => {
        if (l.lat && l.lan) {
          return (
            <Marker
              key={i}
              position={[l.lat, l.lan]}
              eventHandlers={{
                click: () => onSelectData(l),
              }}>
              <Popup ref={popupRef}>
                <div style={{ minWidth: "150px" }}>
                  <strong
                    style={{
                      textAlign: "center",
                    }}>
                    {l.nomi}
                  </strong>
                  <div
                    style={{
                      marginTop: "4px",
                      color: "#555",
                      fontSize: "14px",
                      textAlign: "center",
                    }}>
                    {l.data ? l.data : "-"} {l.birligi ? l.birligi : "mln m3"}
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        } else {
          return null;
        }
      })}
      {locations.length == 0 ? <Marker position={location}></Marker> : null}
    </MapContainer>
  );
}

export default Minimap;
